var map = {
	"./ar_1.mp3": 830,
	"./ar_2.mp3": 8273,
	"./en_1.mp3": 8830,
	"./en_2.mp3": 3121,
	"./fr_1.mp3": 951,
	"./fr_2.mp3": 6016,
	"./ge_1.mp3": 4151,
	"./ge_2.mp3": 4080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8641;